import PropTypes from "prop-types";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import InputText from "../../inputFields/InputText";

class StepComments extends BaseComponent {

  onChange(e, data) {
    this.props.data.setNotiz(data);
  }

  render() {
    let notiz = this.props.data.getNotiz();
    return <InputText
      multiline
      defaultValue={notiz}
      minRows={4}
      labelElement='Bemerkungen'
      helpTextElement='Diese Bemerkung sehen nur Sie'
      onChange={(e, id, data) => this.onChange(e, data)}/>;
  }
}

StepComments.propTypes = {
  data: PropTypes.object
}
export default StepComments;
